import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ResponseDto } from 'src/app/dto/common/response.dto';
import { TypeCodeName } from 'src/app/dto/unit/type.code';
import { UnitDto } from 'src/app/dto/unit/unit.dto';
import { UnitListDto } from 'src/app/dto/unit/unitList.dto';
import { AccountService } from 'src/app/service/account/account.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LocalizationService } from 'src/app/service/localization/localization.service';
import { UnitURL } from '../../constants/url/unit.url';


@Component({
    selector: 'unit',
    templateUrl: '../../view/unit/unit.html'
})
export class UnitComponent {
    @Input() public isVisibleUnitSetting!: boolean;
    @Output() public getToggleVisibleEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output() public userUnitEvent: EventEmitter<UnitDto> = new EventEmitter<UnitDto>();

    public unitListDto: UnitListDto = new UnitListDto();
    public userUnit!: UnitDto;

    constructor(private httpService: HttpService, private accountService: AccountService, private localizationService: LocalizationService) {
        this.getUnitList();
        this.getUserUnit();
    }

    private getUnitList() {
        this.httpService.get(UnitURL.unitList)
            .subscribe(response => {
                let result: any = response;

                if (result.isSuccess) {
                    this.unitListDto = result.data;
                }
            });
    }

    public toggleUnitSettingVisible(): void {
        this.isVisibleUnitSetting = !this.isVisibleUnitSetting;

        if (!this.isVisibleUnitSetting) {
            this.getToggleVisibleEvent.emit();
            this.saveUnitSetting();
        }
    }

    private saveUnitSetting(): void {
        this.userUnit.accountSeq = this.accountService.getAccountSeq();

        this.httpService.post<ResponseDto<Object>>(UnitURL.addUnit, this.userUnit)
            .subscribe(response => {
                if (response.isSuccess) {
                    this.userUnit.setCodes();

                    this.userUnitEvent.emit(this.userUnit);
                }
            });
    }

    public getTypeCodeName(num: number): string {
        return TypeCodeName.getName(num, this.localizationService);
    }

    private getUserUnit() {
        this.httpService.get(UnitURL.userUnit(this.accountService.getAccountSeq()))
            .subscribe(response => {
                let result: any = response;

                if (result.isSuccess) {
                    this.userUnit = Object.assign(new UnitDto(), result.data);
                    this.userUnit.setCodes();

                    this.userUnitEvent.emit(this.userUnit);
                }
            });
    }

    public changeUnit($event: any): void {
        let unitType: number = parseInt($event.target.name);

        switch(unitType) {
            case 0:
                this.userUnit.windSpeedUnit = parseInt($event.target.value);
                break;
            case 1:
                this.userUnit.temperatureUnit = parseInt($event.target.value);
                break;
            case 2:
                this.userUnit.distanceUnit = parseInt($event.target.value);
                break;
        }
    }
}
